import RolledUpTimecard                          from '../../timecard/RolledUpTimecard';
import { TimecardModelBase }                     from '../../timecard/TimecardModel';
import timecardTestEditTimecardsModel            from './TimecardTestEditTimecardsModel';

export default class TimecardTestEditTimecardsRolledUpTimecard extends RolledUpTimecard {
  constructor() {
    super();
  }

  get timecardModel(): TimecardModelBase {
    return timecardTestEditTimecardsModel;
  }
}
